














import { computed, defineComponent, ref } from '@nuxtjs/composition-api'
import { useClassifiedForm } from '~/compositions/form'
import { formFieldProps } from '~/constants/form'
import { useDep } from '~/compositions/dependency-container'
import FormValidationBuilder from '~/builders/form/FormValidationBuilder'
import FieldError from '~/components/car/classifieds/form/fieldsets/fields/FieldError.vue'
import { Ref } from '@vue/composition-api'

export default defineComponent({
  components: { FieldError },
  props: formFieldProps,
  setup(props) {
    const { specs, name } = props
    const value = ref<string>('')
    const onValue = (v: Ref<any>) => {
      value.value = v.value || ''

      if (process.client) {
        // validate changes
        validateTextInput && validateTextInput(value.value)
      }
    }
    const { error, isValid, debouncedValueChanged } = useClassifiedForm(props, {
      onValue
    })
    const formValidationBuilder = useDep(FormValidationBuilder)

    const validateTextInput = (text: string) => {
      if (text === '' && error.value) {
        error.value = null
        return false
      }
      formValidationBuilder
        .new(error)
        .urlIsValid(text)
        .validate()
      return true
    }
    const handleTextInput = (text: string) => {
      if (!validateTextInput(text)) {
        return
      }

      debouncedValueChanged(name, value.value)
    }

    const maxLength = computed(() => specs?.max)
    const placeholder = computed(() => specs?.placeholder)

    return { value, error, isValid, maxLength, placeholder, handleTextInput }
  }
})
